import { View } from 'react-native'
import Head from 'expo-router/head'

import { AppScreenTopBar } from '../../../components/AppScreenTopBar'
import { SettingsContent } from '../components/SettingsContent'
import { SettingsDialogs } from '../components/SettingsDialogs'
import { useSettingsScreenController } from '../logic/useSettingsScreenController'

export default function Settings() {
  const { headTitle, contentProps, dialogProps } = useSettingsScreenController()

  return (
    <View className="flex-1 bg-background-primary">
      <Head>
        <title>{headTitle}</title>
      </Head>
      <AppScreenTopBar />
      <SettingsContent {...contentProps} />
      <SettingsDialogs {...dialogProps} />
    </View>
  )
}
